import React, { useContext } from "react"
import { useCalendarDateLabelStyle } from "./style"
import { PresetContext, WeekDay } from "../context"
import { getUniqueKey } from "Methods/basic"

export default () => {
    const classes = useCalendarDateLabelStyle()
    const { weekDays } = useContext(PresetContext)
    return (
        <div className={classes.header}>
            <div className={classes.label} />
            <div className={classes.content}>
                {
                    weekDays.map(({ day, text }: WeekDay) => (
                        <div key={getUniqueKey()} className={classes.timeLabel}>
                            <div>{text}</div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

